'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, type PropsWithChildren } from 'react';
import { useWebHaptics } from 'web-haptics/react';
type HapticStyle = 'light' | 'medium' | 'heavy' | 'selection' | 'success' | 'warning' | 'error';
export function HapticsProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const {
    trigger
  } = useWebHaptics();
  let t1;
  let t2;
  if ($[0] !== trigger) {
    t1 = () => {
      const validStyles = ["light", "medium", "heavy", "selection", "success", "warning", "error"];
      const clickHandler = function clickHandler(e) {
        if (!(e.target instanceof Element)) {
          return;
        }
        const el = e.target.closest("[data-haptic]");
        const style = el?.getAttribute("data-haptic");
        if (style && (validStyles as string[]).includes(style)) {
          trigger(style as HapticStyle);
        }
      };
      document.addEventListener("click", clickHandler);
      return () => document.removeEventListener("click", clickHandler);
    };
    t2 = [trigger];
    $[0] = trigger;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== children) {
    t3 = <>{children}</>;
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}